import {nonBlank} from "../utils/epic.utils";

export class NavBarItem {

  public id: string;
  public name: string;
  public translation: string;

  constructor(name: string, id?: string) {
    this.id = id ? id : name;
    this.name = name;
    this.translation = name;
  }

  public useName(): NavBarItem {
    this.translation = '';
    return this;
  }

  public hasTranslation(): boolean {
    return nonBlank(this.translation);
  }
}
